import React, { Component } from "react";
import { connect } from "react-redux";
import { updateRelationship } from "../../../domain/accts/acctsActions";
import { closeModal } from "../../../domain/ui/uiActions";
import RelationshipForm from "../../forms/secure/RelationshipForm";
import { FormattedMessage } from "react-intl";
class RelationshipEdit extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div>
				<div className="vr vr_x5">
					<h1 className="hdg">
						<FormattedMessage id="relationshipEdit.header" defaultMessage="Change Relationship"/>
					</h1>
				</div>
				<div className="vr vr_x5">
					<div className="text">
						<FormattedMessage tagName="p" id="relationshipEdit.intro" defaultMessage="To change the relationship, select it from the options below and click Save."/>
					</div>
				</div>
				<div className="vr vr_x5">
					<div className="sides sides_x4S">
						<RelationshipForm accountId={this.props.accountId} closeModal={this.props.closeModal} fieldErrors={this.props.acctsFieldErrors} updateRelationship={this.props.updateRelationship} isLoading={this.props.acctsIsLoading}/>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    accountId: state.accts.accountToEdit,
    acctsFieldErrors: state.accts.relationship.fieldErrors,
    acctsIsLoading: state.accts.relationship.isLoading
});
const bindActionsToProps = {
    closeModal: () => {
        return (dispatch, getState) => {
            const { modalId, triggerId } = getState().ui;
            dispatch(closeModal({
                modalId,
                triggerId
            }));
        };
    },
    updateRelationship
};
/* Create and export container component that wraps RelationshipEdit for property binding */
export default connect(mapStateToProps, bindActionsToProps)(RelationshipEdit);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/modals/RelationshipEdit.tsx